import React from 'react';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventName } from '../../../section/Common/constants';
import { ReactComponent as MuteIcon } from '../../../assets/icons/bell-off-outline-mute.svg';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const MuteAuthor: React.FC<IProps> = ({ book, id, label = 'Author' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={
        <div className='popover-content'>
          {`Mute ${label} for 6 months`}
        </div>
      }
      trigger='hover'
    >
      <MuteIcon
        data-testid='action-mute-author'
        onClick={(e) => {
          e.stopPropagation();

          window.gtag('event', GAEventName.click, {
            identifier: ACTIONS.muteAuthor,
            value: book.Author
          });

          setAction({
            book,
            id,
            type: ACTIONS.muteAuthor
          });
        }}
        className='actions-icons actions-icons-mute'
      />
    </Popover>
  );
};

export default React.memo(MuteAuthor);